import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
// eslint-disable-next-line @typescript-eslint/unbound-method -- Complaining about `this` in Chakra functions?
const { defineMultiStyleConfig  } = createMultiStyleConfigHelpers([
    'container'
]);
export const Card = defineMultiStyleConfig({
    baseStyle: {
        container: {
            background: 'background.white',
            borderRadius: '16px',
            display: 'flex',
            flexDirection: 'column',
            flexShrink: 0
        }
    },
    variants: {
        highlighted: {
            container: {
                alignItems: 'center',
                borderRadius: '0px 8px 8px 0px',
                boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.08);',
                flexDirection: 'row'
            }
        }
    },
    sizes: {
        /* eslint-disable sort-keys -- Semantic order */ xs: {
            container: {
                w: '8.25rem'
            }
        },
        s: {
            container: {
                w: '9.75rem'
            }
        },
        m: {
            container: {
                w: '10.8125rem'
            }
        },
        l: {
            container: {
                w: '16.75rem'
            }
        },
        xl: {
            container: {
                w: '17rem'
            }
        },
        '2xl': {
            container: {
                w: '20.5rem'
            }
        },
        '3xl': {
            container: {
                w: '22.6875rem'
            }
        },
        '4xl': {
            container: {
                w: '34.5rem'
            }
        },
        '5xl': {
            container: {
                w: '37.5rem'
            }
        },
        full: {
            container: {
                w: 'full'
            }
        }
    },
    defaultProps: {
        size: '2xl'
    }
});

//# sourceMappingURL=card.js.map